/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { Flex, FormControl, FormLabel, Select } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaAngleLeft, FaEnvelope, FaSave } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { FindUser } from '../../../../components/FindBox'
import { NavLine } from '../../../../components/NavLine'
import { iNomeId } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { DestinoPosAprovacaoFeedback, FluxoEtapa, PropInvalida, SubstringRoute } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { FormConfiguracaoFeedback } from './components/FormConfiguracaoFeedback'
import { useConfiguracaoFeedback } from './hooks/useConfiguracaoFeedback'

export const ConfigurarFeedback: React.FC = () => {
  const nav = useNavigate()
  const { pathname } = useLocation()
  const isTrilha = FluxoEtapa(pathname)

  const { feedbackId } = useParams<{ feedbackId: string }>()
  const { Model, setModel, IsSaving, Salvar: SalvarConfiguracao, Previsualizar } = useConfiguracaoFeedback(feedbackId)

  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [Reunioes, setReunioes] = useState<iNomeId[]>([])

  function ObterColaboradores(): void {
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
  }

  function ObterReunioes(id: string): void {
    appApi.get(`ReuniaoOne/Select?colaboradorId=${id}`)
      .then(res => setReunioes(res.data))
      .catch(err => console.log(err))
  }

  function Salvar(salvar: boolean): void {
    SalvarConfiguracao(salvar)
      .then(sucesso => {
        if (!sucesso) return
        const destino = DestinoPosAprovacaoFeedback(pathname, Model?.reuniaoId, Model?.participanteId)
        if (destino !== undefined) {
          nav(destino)
        } else {
          nav(-1)
        }
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    ObterColaboradores()
  }, [])

  useEffect(() => {
    if (Model !== undefined && !PropInvalida(Model.participanteId)) {
      ObterReunioes(Model.participanteId)
    }
  }, [Model?.participanteId])

  return (
    <Body isLoading={Model === undefined}>
      <NavLine
        options={[
          { nome: 'Reuniao 1:1', path: `${SubstringRoute(pathname, 'Feedback')}Dashboard/Individual` },
          { nome: 'Feedback' },
          { nome: 'Formularios' },
          { nome: 'Editar formulário', path: -1 },
          { nome: 'Configuração feedback' }
        ]}
      />
      {Model !== undefined &&
        <Flex gap={'1rem'} flexDir='column'>
          <FormConfiguracaoFeedback
            model={Model}
            onChange={setModel}
            onPrevisualizar={Previsualizar}
            exibirDataInicio={!isTrilha}
          >
            {!isTrilha &&
              <FormControl width={'33.625rem'}>
                <FormLabel>Participante</FormLabel>
                <FindUser
                  isDisabled={!PropInvalida(Model.reuniaoId)}
                  selecionado={Model.participanteId}
                  lista={Colaboradores}
                  onChoice={() => { }}
                />
              </FormControl>
            }

            {!isTrilha &&
              <FormControl>
                <FormLabel>Reunião vinculada</FormLabel>
                <Select
                  isDisabled={!PropInvalida(Model.reuniaoId)}
                  value={Model.reuniaoId} width={'20rem'}>
                  <option value={''}>Nenhuma</option>
                  {Reunioes.map((e, i) => {
                    return (
                      <option key={i} value={e.id}>{e.nome}</option>
                    )
                  })}
                </Select>
              </FormControl>
            }
          </FormConfiguracaoFeedback>

          <Flex justifyContent={'end'} gap='1rem'>
            <Button
              onClick={() => nav(-1)}
              size={'lg'}
              VarColor='Gray3'
              leftIcon={<FaAngleLeft />}
            >Voltar</Button>
            {!pathname.includes('Editar') &&
              <Button
                onClick={() => Salvar(false)}
                size={'lg'}
                VarColor='Green2'
                rightIcon={<FaSave />}
                isLoading={IsSaving}
              >Salvar e programar disparo</Button>
            }
            {pathname.includes('Editar') &&
              <Button
                onClick={() => Salvar(false)}
                size={'lg'}
                VarColor='Green2'
                rightIcon={Date.parse(Model.dataInicio) > new Date().getTime() ? <FaSave/> : <FaEnvelope />}
                isLoading={IsSaving}
              >Salvar {Date.parse(Model.dataInicio) > new Date().getTime() ? '' : 'e reenviar'}</Button>
            }
          </Flex>
        </Flex>
      }
    </Body>
  )
}
